import { useMemo } from 'react'
import { Navigate } from 'react-router-dom'

const RootRouteReroute = ({ search }: { search: string }) => {
  const searchParams = useMemo(() => new URLSearchParams(search), [search])

  // ideally, auth0 should redirect directly back to returnTo path,
  // but it defaults to /, which messes up navigation from onRedirectCallback
  if (searchParams.has('code') && searchParams.has('state')) {
    // no fallback UI needed
    return null
  }

  return <Navigate to={`/risk-management${search}`} replace />
}

export default RootRouteReroute
